import { render } from "./uiHeadingMain.vue?vue&type=template&id=7e93228b"
import script from "./uiHeadingMain.vue?vue&type=script&lang=js"
export * from "./uiHeadingMain.vue?vue&type=script&lang=js"
script.render = render

export default script